module.exports = __webpack_public_path__ + "static/media/hai-xian-lao.b4586c40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hai-xian-lao.jpg
// module id = 94
// module chunks = 0